module.exports = __webpack_public_path__ + "static/media/hook.cf52314b.svg";